module.exports = __webpack_public_path__ + "assets/042f896d2e7a8ba0916106a2535dfeb9.mp3";